import { BaseStore } from 'fluxible/addons';
import Actions from '../constants/Actions';

class TransientStore extends BaseStore {

  static storeName = 'TransientStore';

  static handlers = {
    [Actions.UI__LIST_FILTER_SET]: 'setListFilter',
    [Actions.UI__LIST_FILTER_CLEARED]: 'clearListFilter'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.listFilter = '';
  }

  getListFilter() {
    return this.listFilter;
  }

  setListFilter(value) {
    this.listFilter = String(value||'');
    console.info(`setListFilter(${value})`, this.listFilter);
  }

  clearListFilter() {
    this.listFilter = '';
  }
}

export default TransientStore;



// WEBPACK FOOTER //
// ./src/stores/TransientStore.js